var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._l((_vm.headers),function(_,pos){return _c('td',{staticClass:"no-wrap",class:{ pinned: _vm.headers[pos].pinned }},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getValue(pos, _vm.item))}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }